module.exports = __webpack_public_path__ + "static/media/Mexico_Nayarit.e3ca4cac.jpg";